import useLocationState from '../navigation/useLocationState';
import useQueryParams from '../navigation/useQueryParams';

export const getLandingPagePriceIDFromNavigation = (): string | null => {
	const landingPagePriceIDFromQueryParams = useQueryParams().get( 'lp_price_id' );

	const state = useLocationState();
	let landingPagePriceIDFromState: string | null = null;
	if ( typeof state === 'object' && state !== null && 'landingPagePriceID' in state ) {
		landingPagePriceIDFromState = state.landingPagePriceID as string;
	}

	return landingPagePriceIDFromQueryParams ?? landingPagePriceIDFromState;
};

export const getFreeTrialPriceIDFromNavigation = (): string | null => {
	const queryParams = useQueryParams();
	const freeTrialPriceIDFromQueryParams = queryParams.get( 'lp_trial_price_id' );

	const state = useLocationState();
	let freeTrialPriceIDFromState: string | null = null;
	if ( typeof state === 'object' && state !== null && 'freeTrialPriceID' in state ) {
		freeTrialPriceIDFromState = state.freeTrialPriceID as string;
	}

	return freeTrialPriceIDFromQueryParams ?? freeTrialPriceIDFromState;
};

export const getReferralCodeFromNavigation = (): string | null => {
	const referralCodeFromQueryParams = useQueryParams().get( 'referral_code' );

	const state = useLocationState();
	let referralCodeFromState: string | null = null;
	if ( typeof state === 'object' && state !== null && 'referralCode' in state ) {
		referralCodeFromState = state.referralCode as string;
	}

	return referralCodeFromQueryParams ?? referralCodeFromState;
};

export const getGuestHashFromNavigation = (): string | undefined => {
	const state = useLocationState();
	if ( typeof state === 'object' && state !== null && 'guestHash' in state ) {
		return state.guestHash as string;
	}
	return undefined;
};
